import {
  addWarehousePos,
  allWarehousePos,
  deleteWarehousePos,
  updateWarehousePos
} from '@/utils/request'
import vue from '@/main'

const state = {
  warehousePosList: []
}

const mutations = {
  RESET (state) {
    state.warehousePosList = []
  }
}

const actions = {
  all ({ state }) {
    return new Promise((resolve) => {
      allWarehousePos().then(response => {
        state.warehousePosList = response.data
        resolve(state.warehousePosList)
      })
    })
  },
  warehouseById ({ commit, state }, id) {
    for (const team of state.warehousePosList) {
      if (team.id === id) return vue.$_.cloneDeep(team)
    }
    return null
  },
  updateOne ({ state }, warehousePos) {
    return new Promise((resolve) => {
      updateWarehousePos(warehousePos).then(() => {
        for (const cur of state.warehousePosList) {
          if (cur.id === warehousePos.id) {
            Object.assign(cur, warehousePos)
            break
          }
        }
        resolve()
      })
    })
  },
  add ({ commit, dispatch, state }, team) {
    return new Promise((resolve) => {
      addWarehousePos(team).then((response) => {
        state.warehousePosList.push(response.data)
        resolve(response.data)
      })
    })
  },
  delete ({ commit, dispatch, state }, id) {
    return new Promise((resolve) => {
      deleteWarehousePos(id).then(() => {
        for (const i in state.warehousePosList) {
          if (state.warehousePosList[i].id === id) {
            state.warehousePosList.splice(i, 1)
          }
        }
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
